// src/config/environment.js
// Configuración de ambiente para la aplicación

// Configuración de ambiente - Cambia aquí para alternar entre PROD y PREPROD
export const ENVIRONMENT_CONFIG = {
  // Opciones: 'PROD' o 'PREPROD'
  current: process.env.REACT_APP_ENVIRONMENT || 'PROD',
  
  // URLs de PRODUCCIÓN
  PROD: {
    name: 'Producción',
    baseUrl: 'https://servicios.cryoinfra.com.mx/hub_sdl_01/Mensaje/CryoDAC_SDLSFTF_PRO/SDLSFTF_PRO',
    endpoints: {
      consulta: 'FacturaFletera/Consultar',
      actualiza: 'FacturaFletera/Actualizar',
      tiposFactura: 'TipoFactura/Consultar',
      estatusFactura: 'EstatusFactura/Consultar',
      conceptosGasto: 'ConceptoGasto/Consultar'
    }
  },
  
  // URLs de PREPRODUCCIÓN
  PREPROD: {
    name: 'Preproducción',
    baseUrl: 'https://servicios.cryoinfra.com.mx/wsk_sftf/Mensaje/CryoDAC-SFTF/SFTF',
    endpoints: {
      consulta: 'FacturaFletera/Consultar',
      actualiza: 'FacturaFletera/Actualizar',
      tiposFactura: 'TipoFactura/Consultar',
      estatusFactura: 'EstatusFactura/Consultar',
      conceptosGasto: 'ConceptoGasto/Consultar'
    }
  }
};

// Función para obtener la configuración actual
export const getCurrentEnvironment = () => {
  const env = ENVIRONMENT_CONFIG.current;
  return {
    ...ENVIRONMENT_CONFIG[env],
    key: env,
    isProd: env === 'PROD',
    isPreprod: env === 'PREPROD'
  };
};

// Función para cambiar el ambiente (solo para desarrollo)
export const switchEnvironment = (newEnv) => {
  if (newEnv === 'PROD' || newEnv === 'PREPROD') {
    ENVIRONMENT_CONFIG.current = newEnv;
    console.log(`Ambiente cambiado a: ${ENVIRONMENT_CONFIG[newEnv].name}`);
    return true;
  }
  console.error('Ambiente inválido. Use "PROD" o "PREPROD"');
  return false;
};